import i18n from 'i18next';

import { localizedDateFormat } from '@/utils/date';
import { parseLocale } from '@/utils/localeFormatters';

import styles from './ImageMetaInfo.module.scss';

export interface ImageMetaInfoProps {
    time_stamp?: string;
    formatted_time_stamp?: string;
    numberOfImages: number;
    index: number;
    hasImages?: boolean;
}

export default function ImageMetaInfo(props: ImageMetaInfoProps) {
    const { time_stamp, formatted_time_stamp, numberOfImages, index, hasImages = true } = props;

    // Use pre-formatted timestamp if available (normalized to location timezone),
    // otherwise fall back to browser-local formatting
    const formattedTimeStamp =
        formatted_time_stamp ??
        localizedDateFormat({
            dateString: time_stamp,
            onlydate: false,
            locale: parseLocale(i18n.language),
        });

    return (
        <div className={styles.imageMetaInfo}>
            <ul>
                <li>
                    <time dateTime={time_stamp}>{formattedTimeStamp}</time>
                </li>
                {!hasImages && <li>{i18n.t('organisms.imageMetaInfo.noImages')}</li>}
                <li>{`[ ${index + 1}/${numberOfImages} ]`}</li>
            </ul>
        </div>
    );
}
